var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolSegShape = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  cx: 16,
  cy: 15,
  r: 6
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  x: 3,
  y: 3,
  width: 13,
  height: 13,
  rx: 2
}))));
export { SvgToolSegShape as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-seg-shape.svg";